export default {
  mounted(el: HTMLElement) {
    const dragHeader = el.querySelector('.shipInfoDialog-header') as HTMLElement
    const dialog = el

    dragHeader.style.cursor = 'move'

    dragHeader.onmousedown = (e) => {
      const startX = e.clientX
      const startY = e.clientY
      const rect = dialog.getBoundingClientRect()
      const offsetX = startX - rect.left
      const offsetY = startY - rect.top

      const onMouseMove = (e: MouseEvent) => {
        const newX = e.clientX - offsetX
        const newY = e.clientY - offsetY
        dialog.style.left = `${newX}px`
        dialog.style.top = `${newY}px`
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    }
  },
}
